module.exports = __webpack_public_path__ + "img/tab202.93aad006.png";